export const name = 'builderContextProviders' as const
export const ContextProviderRegistrySymbol = Symbol.for('ContextProviderRegistry')
export const ContextProviderLoaderSymbol = Symbol.for('ContextProviderLoader')
export const FunctionLibraryRegistrySymbol = Symbol.for('FunctionLibraryRegistry')
export const BuilderModuleLoaderSymbol = Symbol.for('BuilderModuleLoader')
export const BuilderContextProvidersAttachedStoreSymbol = Symbol.for('BuilderContextProvidersAttachedStore')
export const BuilderContextBindingStoreSymbol = Symbol.for('BuilderContextBindingStore')
